import moment from 'moment-timezone'
import { getAddressStringFromAddressObject, getPharmacyAddressStringFromPharmacyObject } from './common'
import {
  BODY_MEASUREMENT,
  CONTACT_TEXT,
  DATE_FORMAT_TEXT,
  DOB_TEXT,
  EMERGENCY_CONTACT_TEXT,
  FIRST_NAME_TEXT,
  GENDER_IDENTITY,
  HEIGHT_TEXT,
  IDENTITY_SECTION,
  INTAKE_FORM_TYPE_EMAIL_TEXT,
  LAST_NAME_TEXT,
  MARITAL_STATUS_TEXT,
  PERSONAL_TEXT,
  PREFERRED_NAME_TEXT,
  PREFERRED_PHARMACY_TEXT,
  RACIAL_BACKGROUND,
  RELATIONSHIP_TO_PATIENT_TEXT,
  SEX_AT_BIRTH_TEXT,
  STREET_ADDRESS_TEXT,
  WEIGHT_TEXT,
} from './constants'
import { DATE_FORMAT_SLASH } from './dateUtils'
import { VisitMethodOptions } from '../pages/new-visit/components/visit-information/VisitMethods'

export const getGeneralInfoSectionBodMeasurementsConfig = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  height,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  weight,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  maritalStatus,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  sexAtBirth,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  genderIdentity,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  racialBackGround,
}) => [
  {
    title: BODY_MEASUREMENT,
    body: [
      {
        key: HEIGHT_TEXT,
        value: height || '--',
      },
      {
        key: WEIGHT_TEXT,
        value: weight || '--',
      },
    ],
  },
  {
    title: IDENTITY_SECTION,
    body: [
      {
        key: MARITAL_STATUS_TEXT,
        value: maritalStatus || '--',
      },
      {
        key: SEX_AT_BIRTH_TEXT,
        value: sexAtBirth || '--',
      },
      {
        key: GENDER_IDENTITY,
        value: genderIdentity || '--',
      },
      {
        key: RACIAL_BACKGROUND,
        value: racialBackGround || '--',
      },
    ],
  },
]
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAccountInfoConfig = (accountData) => [
  {
    title: PERSONAL_TEXT,
    body: [
      {
        key: FIRST_NAME_TEXT,
        value: accountData?.FirstName || '--',
      },
      {
        key: LAST_NAME_TEXT,
        value: accountData?.LastName || '--',
      },
      {
        key: `${DOB_TEXT} ${DATE_FORMAT_TEXT}`,
        value: accountData?.BirthDate ? moment(accountData?.BirthDate).format(DATE_FORMAT_SLASH) : '--',
      },
      {
        key: PREFERRED_NAME_TEXT,
        value: accountData?.PreferredName || '--',
      },
    ],
  },

  {
    title: CONTACT_TEXT,
    body: [
      {
        key: VisitMethodOptions.PHONE,
        value:
          accountData?.PhoneNumber ?
            `${accountData?.PhoneNumber?.Prefix} ${accountData?.PhoneNumber?.Number?.replace(
              accountData?.PhoneNumber?.Prefix,
              '',
            )}`
          : '--',
      },
      {
        key: INTAKE_FORM_TYPE_EMAIL_TEXT,
        value: accountData?.Email || '--',
      },
      {
        key: STREET_ADDRESS_TEXT,
        value: accountData?.Address ? getAddressStringFromAddressObject(accountData?.Address) : '--',
      },
      {
        key: PREFERRED_PHARMACY_TEXT,
        value: accountData?.Pharmacy ? getPharmacyAddressStringFromPharmacyObject(accountData?.Pharmacy) : '--',
      },
    ],
  },

  {
    title: EMERGENCY_CONTACT_TEXT,
    body: [
      {
        key: FIRST_NAME_TEXT,
        value: accountData?.EmergencyContact?.FirstName || '--',
      },
      {
        key: LAST_NAME_TEXT,
        value: accountData?.EmergencyContact?.LastName || '--',
      },
      {
        key: RELATIONSHIP_TO_PATIENT_TEXT,
        value: accountData?.EmergencyContact?.Relationship || '--',
      },
      {
        key: VisitMethodOptions.PHONE,
        value:
          accountData?.EmergencyContact?.PhoneNumber ?
            `${
              accountData?.EmergencyContact?.PhoneNumber?.Prefix
            } ${accountData?.EmergencyContact?.PhoneNumber?.Number?.replace(
              accountData?.EmergencyContact?.PhoneNumber?.Prefix,
              '',
            )}`
          : '--',
      },
    ],
  },
]
